export default __webpack_public_path__ + "static/about-bg-e68eac92f67b26c6224d454643503687.png";